export const LOGO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_finance-match-15/artifacts/hjw899hl_WhatsApp%20Image%202026-07-15%20at%2021.37.37.jpeg";
export const INSTAGRAM_URL = "https://www.instagram.com/loaneightyone?igsh=MTluM3Jwa2EybW1ucg==";
export const FACEBOOK_URL = "https://www.facebook.com/share/1DbQH6ae6b/";
export const CONTACT_EMAIL = "loan81.info@gmail.com";
export const CONTACT_PHONE = "9312201464";
